// extracted by mini-css-extract-plugin
export default {"scenario":"scenario_scenario__aAX9I","scenario__content":"scenario_scenario__content__f5Jkq"};